import * as GenericRedux from '../../../generic/genericRedux'

export interface CommunityConfiguration {
  id: number,
  community_id: string,
  config_key?: string,
  config_value?: string,
  key?: string,
  value?: string,
  configuration_source: string,
  community_partner_id?: number | null,
  community_partner_code?: string | null,
  description?: string,
  created_at?: string,
  updated_at?: string,
}

export interface EmptyCommunityConfiguration {
  id: null,
  community_id: '',
  config_key: '',
  config_value: '',
  configuration_source: '',
  description: '',
  created_at: null,
  updated_at: null,
}

export const EmptyDisplayCommunityConfiguration: EmptyCommunityConfiguration = {
  id: null,
  community_id: '',
  config_key: '',
  config_value: '',
  configuration_source: '',
  description: '',
  created_at: null,
  updated_at: null,
}

export interface NewsletterCategory {
  id: number,
  name: string,
  display_name: string,
  is_active: boolean,
  maximum?: string,
  minimum?: string,
  max_preferred?: string,
  max_lead?: string,
  max_per_source?: string,
}


export interface CommunityConfigurationState {
  communityId: number,
  communityIdentifier: string,
  allConfigurations: CommunityConfiguration[],
  defaultConfigurations: CommunityConfiguration[],
  communityConfigurations: CommunityConfiguration[],
  segmentConfigurations: Record<string, CommunityConfiguration[]>,
  segmentExpanded: Record<string, boolean>,
  newsletterCategories: NewsletterCategory[],
  isLoading: boolean,
  error: string,
  isSuperUser: boolean,
  defaultSectionExpanded: boolean,
  communitySectionExpanded: boolean,
  newsletterSectionExpanded: boolean,
  editingConfigId: number | null,
  editingValue: string,
  editingNewsletterCell: { categoryId: number, field: string } | null,
  editingNewsletterValue: string,
  modalFormData: {
    config_key: string,
    config_value: string,
    config_type: string,
  },
}

export type CommunityConfigurationProps = GenericRedux.AllComponentPropsWithModal<CommunityConfiguration>

export interface NewConfigurationData {
  communityId: string,
  config_key: string,
  config_value: string,
  description?: string,
}